import React, { useState } from 'react'

// query
import { useMutation } from '@apollo/client'
import { BULK_CREATE_INVENTORY_RECEIVING_LOG } from '../../../../../graphql/inventoryReceivingLog/inventoryReceivingLog.mutations'
import { GET_EQUIPMENT_PURCHASE_ORDERS_BY_STATUS } from '../../../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries'

// components
import SideViewModal from '../../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import ReceivingPurchaseOrder from './ReceivingPurchaseOrder.form'
import ReceivingFromJobSite from './ReceivingFromJobSite.form'
import ReceivingOther from './ReceivingOther.form'

// utils
import { createSubmitData } from './ReceivingLog.form.controller.utils'
import { validate } from '../../../../../shared/utility'

const rootValidationSchema = {
    date: {
        type: 'date',
        validation: {
            required: true,
            isDate: true
        }
    },
    time: {
        type: 'time',
        validation: {
            required: true,
            isTime: true
        }
    },
    
}

export default function ReceivingLogFormController({ visible, closeForm }) {
    const [createReceivingLog, {}] = useMutation(BULK_CREATE_INVENTORY_RECEIVING_LOG)
    const [errors, setErrors] = useState({ equipment: []})

    // handle the form submission
    const handleSubmit = ({ variant, finalData }) => {
        
        let validationSchema = {...rootValidationSchema}
        switch(variant) {
            case 3:
                validationSchema['equipment'] = {
                    type: 'list',
                    fields: {
                        quantityReceived: {
                            type: 'input',
                            validation: {
                                required: true
                            }
                        }
                    }
                }
                break

            case 2:
                validationSchema['fromJob'] = {
                    type: 'input',
                    validation: { required: true }
                }
                validationSchema['equipment'] = {
                    type: 'list',
                    fields: {
                        quantityReceived: {
                            type: 'input',
                            validation: {
                                required: true
                            }
                        }
                    }
                }
                break

            case 1:
                validationSchema['fromPurchaseOrder'] = {
                    type: 'input',
                    validation: { required: true }
                }
                validationSchema['equipment'] = {
                    type: 'list',
                    fields: {
                        quantityReceived: {
                            type: 'input',
                            validation: {
                                required: true
                            }
                        }
                    }
                }
                break

            default:
                break
        }

        const { isValid, errors } = validate(finalData, validationSchema)

        if(isValid) {
            const submitData = createSubmitData(finalData)
            createReceivingLog({ variables: {...submitData}, refetchQueries:[GET_EQUIPMENT_PURCHASE_ORDERS_BY_STATUS]}).catch(e => {
            }).then(result => {
                if(result) {
                    setErrors({ equipment: [] })
                    closeForm()
                }
            })
        } else {
            setErrors(errors)
        }
        
    }

    if(visible) {
        const variants = [
            { 
                name: 'From Purchase Order',
                component: <ReceivingPurchaseOrder />,
                stages: 2
            }, 
            { 
                name: 'From Job Site',
                component: <ReceivingFromJobSite />,
                stages: 2
            },
            {
                name: 'Other',
                component: <ReceivingOther />,
                stages: 1
            }
        ]

        return (<SideViewModal 
            show={visible} 
            submitText='Complete Receiving'
            onSubmit={handleSubmit}
            onClose={() => {
                setErrors({ equipment: [] })
                closeForm()
            }}  
            title='Receiving'
            variants={variants}
            errors={errors}
        />)
    }

    return null
}